import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Country {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
}

const countries: Country[] = [
  { code: "BR", name: "Brasil", dialCode: "+55", flag: "🇧🇷" },
  { code: "PT", name: "Portugal", dialCode: "+351", flag: "🇵🇹" },
  { code: "US", name: "Estados Unidos", dialCode: "+1", flag: "🇺🇸" },
  { code: "CA", name: "Canadá", dialCode: "+1", flag: "🇨🇦" },
  { code: "AR", name: "Argentina", dialCode: "+54", flag: "🇦🇷" },
  { code: "CL", name: "Chile", dialCode: "+56", flag: "🇨🇱" },
  { code: "CO", name: "Colômbia", dialCode: "+57", flag: "🇨🇴" },
  { code: "MX", name: "México", dialCode: "+52", flag: "🇲🇽" },
  { code: "PE", name: "Peru", dialCode: "+51", flag: "🇵🇪" },
  { code: "UY", name: "Uruguai", dialCode: "+598", flag: "🇺🇾" },
  { code: "PY", name: "Paraguai", dialCode: "+595", flag: "🇵🇾" },
  { code: "BO", name: "Bolívia", dialCode: "+591", flag: "🇧🇴" },
  { code: "EC", name: "Equador", dialCode: "+593", flag: "🇪🇨" },
  { code: "VE", name: "Venezuela", dialCode: "+58", flag: "🇻🇪" },
  { code: "ES", name: "Espanha", dialCode: "+34", flag: "🇪🇸" },
  { code: "FR", name: "França", dialCode: "+33", flag: "🇫🇷" },
  { code: "DE", name: "Alemanha", dialCode: "+49", flag: "🇩🇪" },
  { code: "IT", name: "Itália", dialCode: "+39", flag: "🇮🇹" },
  { code: "GB", name: "Reino Unido", dialCode: "+44", flag: "🇬🇧" },
  { code: "NL", name: "Holanda", dialCode: "+31", flag: "🇳🇱" },
  { code: "BE", name: "Bélgica", dialCode: "+32", flag: "🇧🇪" },
  { code: "CH", name: "Suíça", dialCode: "+41", flag: "🇨🇭" },
  { code: "AT", name: "Áustria", dialCode: "+43", flag: "🇦🇹" },
  { code: "PL", name: "Polônia", dialCode: "+48", flag: "🇵🇱" },
  { code: "JP", name: "Japão", dialCode: "+81", flag: "🇯🇵" },
  { code: "CN", name: "China", dialCode: "+86", flag: "🇨🇳" },
  { code: "KR", name: "Coreia do Sul", dialCode: "+82", flag: "🇰🇷" },
  { code: "IN", name: "Índia", dialCode: "+91", flag: "🇮🇳" },
  { code: "AU", name: "Austrália", dialCode: "+61", flag: "🇦🇺" },
  { code: "NZ", name: "Nova Zelândia", dialCode: "+64", flag: "🇳🇿" },
  { code: "ZA", name: "África do Sul", dialCode: "+27", flag: "🇿🇦" },
  { code: "AE", name: "Emirados Árabes", dialCode: "+971", flag: "🇦🇪" },
  { code: "IL", name: "Israel", dialCode: "+972", flag: "🇮🇱" },
  { code: "RU", name: "Rússia", dialCode: "+7", flag: "🇷🇺" },
  { code: "TR", name: "Turquia", dialCode: "+90", flag: "🇹🇷" },
];

interface CountryCodeSelectProps {
  value: string;
  onChange: (value: string) => void;
}

export const CountryCodeSelect = ({ value, onChange }: CountryCodeSelectProps) => {
  // Extract dial code from value (format: "+XX" or "+XX-CC")
  const dialCode = value.includes('-') ? value.split('-')[0] : value;
  const selectedCountry = countries.find(c => c.dialCode === dialCode) || countries[0];

  const handleChange = (newValue: string) => {
    // Extract just the dial code from the value
    const code = newValue.split('-')[0];
    onChange(code);
  };

  return (
    <Select value={`${selectedCountry.dialCode}-${selectedCountry.code}`} onValueChange={handleChange}>
      <SelectTrigger className="w-[100px] bg-background">
        <SelectValue>
          <span className="flex items-center gap-1.5">
            <span className="text-base">{selectedCountry.flag}</span>
            <span className="text-sm">{selectedCountry.dialCode}</span>
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-popover z-50 max-h-[300px]">
        {countries.map((country) => (
          <SelectItem key={country.code} value={`${country.dialCode}-${country.code}`}>
            <span className="flex items-center gap-2">
              <span className="text-base">{country.flag}</span>
              <span className="text-sm">{country.name}</span>
              <span className="text-muted-foreground text-xs">{country.dialCode}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
